<template>
  <sweet-modal ref="modal" overlay-theme="dark">
    <!-- Step 1 -->
    <section class="text-left" v-if="currentStep === 1">
      <div class="row">
        <div class="col-12">
          <div class="mb-4 text-center" v-if="imageUrl">
            <img :src="imageUrl" alt="" class="img-fluid">
          </div> 
          <h3 class="text-center">{{ title }}</h3>
          <div class="text-center pb-3">
            {{ description }}
          </div>
          <div class="card bg-light">
            <div class="card-body text-center">
              {{ $t('message.my_reservations.cancel_message') }}
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-start">
            <div class="flex-grow-1 pr-3">
              <a href="https://line.me/R/ti/p/%40hnk7011n"
                target="_blank"
                class="btn btn-info btn-block">
                {{ $t('message.button.contact_admin') }}
              </a>
            </div>
            <div>
              <a href="https://line.me/R/ti/p/%40hnk7011n"
                target="_blank">
                <img src="/static/img/ic_operator.png" alt="" class="img-fluid">
              </a>
            </div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <!-- @click="cancelOrder()" -->
          <button class="btn btn-link btn-block text-info" @click="checkNextStep()" :disabled="isLoading">
            {{ isLoading ? $t('message.button.loading') : $t('message.button.confirm_cancel_booking') }}
          </button>
        </div>
      </div>
    </section>
    <section class="text-left" v-else-if="currentStep === 2">
      <div class="row">
        <div class="col-12">
          <h3>{{ $t('message.my_reservations.cancel_dialog_question') }}</h3>
        </div>
        <div class="col-12">
          <b-form-group class="pl-3">
            <template v-for="cancelType in cancelTypes">
              <b-form-radio v-model="selectedCancelType"
                            class="p-2"
                            name="some-radios"
                            :value="cancelType">{{ cancelType | multiLangName }}
              </b-form-radio>
            </template>
          </b-form-group>
        </div>
        <div class="col-12 mb-4" v-if="selectedCancelType && selectedCancelType.id === 1">
          <textarea class="form-control"
                    :class="{'form-alert': errorMessage}"
                    rows="2"
                    :placeholder="$t('message.my_reservations.cancel_remark')"
                    v-model="remark"></textarea>
          <div class="text-danger text-remark pt-2" v-if="errorMessage && !remark">{{ errorMessage }}</div>
        </div>
        <div class="col-12 pb-4" v-if="selectedCancelType && selectedCancelType.allow_contact === 1">
          <a href="https://line.me/R/ti/p/%40hnk7011n"
             target="_blank"
             class="btn btn-outline-info btn-block">
            {{ $t('message.button.contact_admin') }}
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button class="btn btn-outline-info btn-block" @click="closeModal()">
            {{ $t('message.button.close') }}
          </button>
        </div>
        <div class="col" v-if="!selectedCancelType || (selectedCancelType && selectedCancelType.allow_contact === 0)">
          <button class="btn btn-info btn-block" @click="cancelOrder()">
            {{ $t('message.button.confirm') }}
          </button>
        </div>
      </div>
    </section>
    <!-- Step 2 -->
  </sweet-modal>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'
  import axios from 'axios'

  export default {
    props: {
      orderId: Number,
      userId: Number
    },
    components: {
      SweetModal
    },
    data () {
      return {
        currentStep: 1,
        imageUrl: null,
        title: null,
        description: null,
        showModal: false,
        cancelCondition: null,
        cancelTypes: null,
        selectedCancelType: null,
        remark: null,
        errorMessage: null,
        isLoading: false
      }
    },
    methods: {
      checkNextStep () {
        let validation = true
        this.errorMessage = null
        if (this.selectedCancelType && this.selectedCancelType.id === 1 && !this.remark) {
          validation = false
          this.errorMessage = this.$i18n.t('message.required_field')
        }
        if (validation) {
          this.currentStep = 2
        }
      },
      cancelConditionTitle () {
        this.title = this.$i18n.t('message.confirm.title')
        switch (this.cancelCondition) {
          case 1:
            this.title = this.$i18n.t('message.my_reservations.cancel_refund_title_01')
            this.description = this.$i18n.t('message.my_reservations.cancel_refund_detail_01')
            this.imageUrl = null
            break
          case 2:
            this.title = this.$i18n.t('message.my_reservations.cancel_refund_title_02')
            this.description = this.$i18n.t('message.my_reservations.cancel_refund_detail_02')
            this.imageUrl = '/static/img/ic_greater_24hr.png'
            break
          case 3:
            this.title = this.$i18n.t('message.my_reservations.cancel_refund_title_03')
            this.description = this.$i18n.t('message.my_reservations.cancel_refund_detail_03')
            this.imageUrl = '/static/img/ic_less_24hr.png'
            break
          case 4:
            this.title = this.$i18n.t('message.my_reservations.cancel_refund_title_04')
            this.description = this.$i18n.t('message.my_reservations.cancel_refund_detail_04')
            this.imageUrl = '/static/img/ic_less_2hr.png'
            break
        }
      },
      async fetchCancelCondition () {
        const url = `orders/${this.orderId}/cancel-condition`
        let {data} = await axios.get(url)
        if (data) {
          this.cancelCondition = data.cancel_condition
          this.cancelTypes = data.cancel_types
          this.cancelConditionTitle()
        }
      },
      async cancelOrder () {
        this.isLoading = true
        const url = `orders`
        const submitData = {
          order_id: this.orderId,
          user_id: this.userId,
          cancel_type_id: this.selectedCancelType.id,
          remark: this.remark
        }
        let {data} = await axios.delete(url, {data: submitData})
        this.isLoading = false
        // console.log('submit data1', data)
        // console.log('submit data2', submitData)
        if (data) {
          if (!data.error) {
            this.$emit('cancelledOrder', true)
            this.closeModal()
          } else {
            this.$swal({text: 'Error:' + data.message, type: 'error'})
          }
        }
      },
      openModal () {
        this.$refs.modal.open()
        this.currentStep = 1
        this.cancelCondition = null
        this.selectedCancelType = null
        this.remark = null
        this.fetchCancelCondition()
      },
      closeModal () {
        this.$refs.modal.close()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/CancelOrderModal.vue